import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { mercurioStore } from '@Store/mercurio';

// Hook
import { valPackage } from '@Hooks/useValidatePlanet';

// Images
import _tank from '@Assets/images/tanque.png';
import _lock from '@Assets/images/lock.png';
import mercurio from '@Assets/images/planets/mercurio.svg';

// Styles
import style from '@Components/Planets/planets.module.scss';
import buttons from '@Sass/components/buttons.module.scss';
import lines from '@Components/Planets/lines.module.scss';

export const Mercurio = ({ mercurioInfo }) => {
  const [skills, setSkills] = useState([
    {
      skill: '',
    },
  ]);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('MERCURIO');

  // Store de mercurio
  const { getMercurio, dataMercurio } = mercurioStore(
    (state) => ({
      getMercurio: state.getMercurio,
      dataMercurio: state.dataMercurio,
    }),
    shallow
  );

  const { validateProject } = valPackage();

  useEffect(() => {
    if (mercurioInfo.titulo) {
      setSkills(mercurioInfo.skills);
      setDescription(mercurioInfo.descripcion);
      setTitle(mercurioInfo.titulo);
    }
  }, [mercurioInfo]);

  return (
    <div>
      <div className={style.cardItem}>
        <div className={style.card_name_tankItem}>
          <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
          <div className={style.card_tank_value}>
            <label>x1</label>
            <img src={_tank} alt="tank" />
          </div>
        </div>
        <div className={`${style.planetImage_content} ${lines.lines_mercurio} `}>
          <div className={lines.lines_mercurio_1}>
            <p dangerouslySetInnerHTML={{ __html: skills[0].skill }}></p>
          </div>
          {getMercurio().lockedPlanet === 'desbloqueado' ? (
            <></>
          ) : (
            <img src={_lock} alt="lock" className={style.imgLock} />
          )}
          <img src={mercurio} alt="planet" className={`${style.planetImage}  ${style.mercurio}`} />
        </div>
        <div className={style.planetInfo}>
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>

        <div className={style.planetButton_content}>
          {getMercurio().id ? (
            <button
              className={`${
                dataMercurio.complete === 1
                  ? buttons.buttonPlanetCompleted
                  : dataMercurio.complete === 2
                  ? buttons.buttonPlanetIncomplete
                  : dataMercurio.complete === 0
                  ? buttons.buttonPlanet
                  : buttons.buttonPlanet
              }`}
              onClick={() => validateProject('mercurio', 1)}
            >
              {dataMercurio.label}
            </button>
          ) : (
            <button className={style.moon_launchBtn} onClick={() => validateProject('mercurio', 1)}>
              ACCEDER
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
